import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

export default async function ongroundCreate(
  email,
  firstName,
  lastName,
  gender,
  mobileNumber,
  rfid,
  tiers,
  action,
  paymentMethod,
  party,
  slotId = null,
  isDummy = false,
  ticketQuantity = 1,
  idempotencyKey = null
) {
  let body = {
    email,
    firstName,
    lastName,
    gender,
    mobileNumber,
    tiers,
    action,
    party,
    isDummy,
    ticketQuantity,
  };
  if (slotId != null && slotId !== "") {
    body.slotId = slotId;
  }
  if (rfid) {
    body.rfid = rfid;
  }
  if (paymentMethod) {
    body.purchaseType = paymentMethod;
  }
  if (idempotencyKey) {
    body.idempotencyKey = idempotencyKey;
  }
  const { data } = await axios.post(
    routes.customersOngroundCreate,
    {
      ...body,
    },
    { ...AXIOS_DEFAULT_CONFIG, timeout: 60000 }
  );

  return data;
}
